// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__AZnHK","footer":"ModalCreateQualiphyProcedure_footer__tKBCQ","additionData":"ModalCreateQualiphyProcedure_additionData__1VLvP"};